$ = require 'jquery'
AttachmentViewerView = require 'views/attachment/attachment-viewer-view'

module.exports =
  clear: ->
    if @isActive()
      @viewer.$el.off 'remove.attachment-viewer', @_handleViewRemove
      @viewer.close()
      @viewer = null
    return

  isActive: ->
    @viewer?

  _handleViewRemove: ->
    @viewer = null

  show: (options) ->
    @clear()

    @viewer = new AttachmentViewerView(options)
    # The attachment viewer may remove itself from the DOM
    @viewer.$el.on 'remove.attachment-viewer', @_handleViewRemove.bind(@)

    # The attachment viewer view will .remove() itself when it's done
    $('#classic').append @viewer.render().el
    return



// WEBPACK FOOTER //
// ./app/scripts/views/internal/attachment-viewer.coffee